/**
 * @Author: chengzh
 * @Date:   2021-07-07 10:05:16
 * @Last Modified by:   chengzh
 * @Last Modified time: 2021-08-24 16:43:20
 */
import request from '@/utils/request';
import getConfig from 'next/config';
import { sessionStorage, localStorage } from '@/utils';
const { publicRuntimeConfig } = getConfig();
// 从环境变量中取MODE，配置在next.config.js和package.json文件中
const mode = publicRuntimeConfig.env.NEXT_PUBLIC_MODE;
// console.log('publicRuntimeConfig', publicRuntimeConfig);
// console.log('mode', mode);


/**
 * 收银台初始化
 * @param {*} key
 */
export async function getCashierData(key) {
  let docRefer = document.referrer

  sessionStorage.getItem('llpayReferrer') ? null : sessionStorage.setItem('llpayReferrer', docRefer);
  if (mode === 'mock') {
    return request(`/api/cashierData`);
  }
  return request(`/api/payment/cashier/info/${key}`, {
    method: 'GET',
  });
}
/**
 * 产品信息初始化
 * @param {*} key
 */
 export async function getInitProductsOrder(key) {
  if (mode === 'mock') {
    return request(`/api/productsOrder`);
  }
  // console.log('调试的key：',key)
  return request(`/api/payment/${key}/products`, {
    method: 'GET',
  });
}

/**
 * 支付页面初始化 【国际信用卡、本地支付、快捷支付、】
 * @param {*} key
 */
export async function getInitCardInfo(type, key) {
  if (mode === 'mock') {
    return request(`/api/initCardInfo`);
  }
  let paymentType = type;
  //? 和张浩约定，无论是否是3DS页面，只要是第一次进入（传给后端的值refreshTimes=1），后端返回，如果存在lastResponseCode,就弹窗提醒，其他刷新，后端将不再返回lastResponseCode的值。
  let refreshTimes = sessionStorage.getItem('refreshTimes') || 0;
  ++refreshTimes;
  sessionStorage.setItem('refreshTimes', refreshTimes);
  return request(
    `/api/payment/${paymentType}/info/${key}?refreshTimes=${refreshTimes}`,
    {
      method: 'GET',
    },
  );
}

/**
 * 获取账单地址
 * @param {*} key
 * @param {*} params
 * 参数
 * type 必传 country=查国家，state=查州，city=查城市
 * prevCode 1、查国家的时候不需要传；2、查州的时候，传国家的code；3、查城市的时候，传国家和州code的拼接，如BRAC，BR是国家的code，AC是州的code
 */
export async function getAddresses (key, params) {
  return request(`/api/addresses/${key}`, {
    method: 'POST',
    body: params,
  });
}

/**
 * 支付 【国际信用卡、本地支付、快捷支付、】
 * @param {*} key
 * @param {*} params
 */
export async function paymentPayflow (type, key, params) {
  let paymentType = type;
  return request(`/api/payment/${paymentType}/payflow/${key}`, {
    method: 'POST',
    body: params,
  });
}


/**
 * 轮询支付结果 （轮询方式）
 * @param {*} key
 * @param {*} params
 */
 export async function paymentPollingQuery (key) {
  return request(`/api/payment/payresult/round/${key}`, {
    method: 'GET',
  });
 }

 /**
 * 获取支付结果信息（非轮询方式）
 * @param {*} key
 * @param {*} params
 */
 export async function paymentResultQuery (key) {
  return request(`/api/payment/payresult/info/${key}`, {
    method: 'GET',
  });
}

/**
 * 支付 【国际信用卡、本地支付、快捷支付、】
 * @param {*} key
 * @param {*} params
 */
 export async function paymentJaPayflow (type, key, params) {
  let paymentType = type;
  return request(`/api/payment/${paymentType}/payflow/${key}`, {
    method: 'POST',
    body: params,
  });
}


/**
 * PIX支付结果
 * @param {*} key
 * @param {*} params
 */
export async function paymentPayResult (type, key) {
  let paymentType = type;
  return request(`/api/payment/${paymentType}/payresult/${key}`, {
    method: 'GET',
  });
}

/**
 * 3DS页面获取接口
 * GET
 * @param {*} key
 * @param {*} params
 */
export async function tdsInfo (key) {
  return request(`/api/payment/3ds/info/${key}`);
}

/**
 * 卡bin查询
 * POST
 * /info/cb/{key}
 * Body:encrypted,token
 * encrypted 加密密文，明文内容如：{"cardNo":"745744758475"}
 */
export async function infoCb (key, params) {
  return request(`/api/info/cb/${key}`, {
    method: 'POST',
    body: params,
  });
}

/**
 * 快捷支付（验证并支付）
 * POST
 * /payment/iframe/qpt/validate/{key}
 *
}
 */
export async function qptValidate (key, params) {
  return request(`/api/payment/qpt/validate/${key}`, {
    method: 'POST',
    body: params,
  });
}

/**
 * 快捷支付（重新发送短信）
 * POST
 * /payment/iframe/qpt/resend/{key}
 *
 */
export async function qptResend (key, params) {
  return request(`/api/payment/qpt/resend/${key}`, {
    method: 'POST',
    body: params,
  });
}

/**
 * Boleto支付详情页展示
 * /payment/bol/paydetail/{key}
 * @param {*} key
 * @param {*} params
 */
export async function bolPayDetail (key) {
  if (mode === 'mock') {
    return request(`/api/bol`);
  }
  return request(`/api/payment/bol/paydetail/${key}`);
}

/**
 * 收银台设备指纹采集后支付
 * POST
 * /payment/cashier/3ds/devicePayflow/{key}
 * key为tdsKey
 *
 */
export async function paymentCashier3dsDevicePayflow (key, params) {
  // if (mode === 'mock') {
  //   return request(`/api/3ds/devicePayflow`);
  // }
  return request(`/api/payment/cashier/3ds/devicePayflow/${key}`, {
    method: 'GET',
  });
}

/**
 * 信用卡分期-根据总金额计算
 * POST
 * /payment/lcr/installment/payplan
 *
 */
export async function paymentLcrInstallmentPayplan (params) {
  if (mode === 'mock') {
    return request(`/api/payplan`);
  }
  return request(`/api/payment/lcr/installment/payplan`, {
    method: 'POST',
    body: params,
  });
}



/**
 * 收银台 银行卡/ThaiQR/手机银行/支付链接 初始化
 * @param {*} params
 */
export async function initialQuery(params, referrer) {
  const newParams  = {...params}

  return request(
    `/api/gateway?${stringify(newParams)}`,
    {
      method: 'GET',
    },
    referrer
  )
}

/**
 * 支付
 * 支付链接 提交表单
 * @param {} params
 */
export async function checkoutPayment(params, referrer) {

  const newParams  = {...params}
  return request(
    `/api/gateway`,
    {
      method: 'POST',
      body: newParams,
    },
    referrer
  )
}